import { render, staticRenderFns } from "./RootView.vue?vue&type=template&id=4d14c7d6&scoped=true&"
import script from "./RootView.vue?vue&type=script&lang=js&"
export * from "./RootView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d14c7d6",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/views/RootView.vue
// module id = 186
// module chunks = 32